// extracted by mini-css-extract-plugin
export var askAiIcon = "_qp-9";
export var container = "_qp-0";
export var groupSeparator = "_qp-a";
export var highlight = "_qp-4";
export var resultIcon = "_qp-5";
export var resultItem = "_qp-7";
export var resultSubtitle = "_qp-3";
export var resultTitle = "_qp-2";
export var resultsList = "_qp-1";
export var searchGroup = "_qp-6";
export var selected = "_qp-8";